<template>
  <div class="handle-order">
    <div class="main">
      <!-- <el-button :type="btType" size="mini" round @click="handleTimeLimit(orderType)" v-if="orderType!=='send_text_info'">
        <span>{{ orderName }}</span>
      </el-button> -->
      <!-- <el-button :type="btType" size="mini" round @click="handleTimeLimit(orderType)" v-else>
        <span>{{ orderName }}</span>
      </el-button> -->
      <el-dropdown style="flex: none;margin: 0 6px;" @command="handleTimeLimit" v-if="orderType==='send_text_info'">
        <el-button type="primary" size="mini" round>
          {{ orderName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="send_text_info">{{$t('ctch1')}}</el-dropdown-item>
          <el-dropdown-item command="cancel_text_info">{{$t('ctch2')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown style="flex: none;margin: 0 6px;" @command="handleTimeLimit" v-if="orderType==='program_play_by_name'">
        <el-button type="primary" size="mini" round>
          {{ orderName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="program_play_by_name">发布紧急版式</el-dropdown-item>
          <el-dropdown-item command="cancel_text_info">取消紧急版式</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button :type="btType" size="mini" round @click="handleTimeLimit(orderType)" v-if="isDropdown(orderType)">
        <span>{{ orderName }}</span>
      </el-button>
    </div>
    <del-dialog :title="`${orderName}`" :dialogVisible="delDialogVisible" @closeDialog="delCloseDialog" :isAppend="true">
      <div style="
          width: 100%;
          height: 40px;
          text-align: center;
          padding-top: 20px;
          font-size: 16px;
        ">
        <template v-if="orderType === 'restart_control'">{{
          $t("terminal.orderTip")
        }}</template>
        <template v-if="orderType === 'offscreen_control'">{{
          $t("terminal.orderTip1")
        }}</template>
        <template v-if="orderType === 'onscreen_control'">{{
          $t("terminal.orderTip2")
        }}</template>
        <template v-if="orderType === 'capture_save'">{{$t('ctch3')}}</template>
        <template v-if="orderType === 'schedule_back'">是否要进行播表撤回？</template>
      </div>
    </del-dialog>
    <form-dialog :title="`${orderName}`" :dialogVisible="lightDialog" @closeDialog="lightCloseDialog" :isAppend="true">
      <el-form label-width="105px" :model="lightForm" @submit.native.prevent>
        <el-form-item :label="`${orderName}`">
          <!-- <el-input v-model.number="lightForm.value"></el-input> -->
          <div class="voice-control">
            <el-slider v-model.number="lightForm.value" style="width: 150px; margin-left: 15px"></el-slider>
            <el-input-number controls-position="right" :min="0" :max="100" size="small" class="voicenumber" v-model.number="lightForm.value"></el-input-number>
          </div>
        </el-form-item>
      </el-form>
      <div class="flex-a-c" style="width: 160px; margin: 0 auto">
        <el-button round @click="lightCancel">{{
          $t("terminal.cancel")
        }}</el-button>
        <el-button type="primary" round @click="confirmLight">{{
          $t("terminal.confirm")
        }}</el-button>
      </div>
    </form-dialog>
    <form-dialog :title="$t('terminal.scSetting')" :dialogVisible="scheduleDialog" @closeDialog="scheduleCloseDialog" dWidth="960px" :isAppend="true">
      <div class="s_content">
        <div class="s_head">
          <el-select v-model="sc_device" :placeholder="$t('terminal.selectTip1')" @change="getScheduleTemplateDetail">
            <el-option v-for="item in schedules_option" :key="item.id" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <img src="~@/assets/images/program/program_delete.png" style="float: right; width: 34px; height: 34px" @click="delete_template(item.id)" />
            </el-option>
          </el-select>
          <el-button type="primary" @click="addTimeOrder" :disabled="sc_device == ''" round size="mini">+{{ $t("terminal.selectTip2") }}</el-button>
        </div>
        <div class="s_table">
          <el-table :data="sc_table_data" :empty-text="$t('terminal.selectTip3')" v-loading="loading" height="100%">
            <el-table-column prop="action" :label="$t('terminal.conOrder')" align="center" width="140">
              <template slot-scope="scope">
                <span v-if="scope.row.action == 1">{{
                  $t("terminal.action1")
                }}</span>
                <span v-if="scope.row.action == 2">{{
                  $t("terminal.action2")
                }}</span>
                <span v-if="scope.row.action == 3">{{
                  $t("terminal.action3")
                }}</span>
                <span v-if="scope.row.action == 4">{{
                  $t("terminal.action4")
                }}</span>
                <span v-if="scope.row.action == 5">{{
                  $t("terminal.action5")
                }}</span>
                <span v-if="scope.row.action == 6">{{
                  $t("terminal.action6")
                }}</span>
                <span v-if="scope.row.action == 7">{{
                  $t("terminal.action7")
                }}</span>
                <span v-if="scope.row.action == 8">{{
                  $t("terminal.action8")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('terminal.value')" width="140" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.action == 6">
                  <template v-if="scope.row.value == 1">{{
                    $t("terminal.acVa1")
                  }}</template>
                  <template v-if="scope.row.value == 2">{{
                    $t("terminal.acVa2")
                  }}</template>
                  <template v-if="scope.row.value == 3">{{
                    $t("terminal.acVa3")
                  }}</template>
                </template>
                <template v-else-if="scope.row.action == 7 || scope.row.action == 8">{{
                    `${
                      scope.row.pcList.length == 0
                        ? `${$t("terminal.noData")}`
                        : scope.row.pcList
                    }`
                  }}</template>
                <template v-else>{{ scope.row.value }}</template>
              </template>
            </el-table-column>
            <el-table-column prop="startTime" :label="$t('terminal.excTime')" width="140" align="center"></el-table-column>
            <el-table-column prop="isDateLimit" :label="$t('terminal.dateOk')" width="140" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" :content="`${scope.row.dateStart}-${scope.row.dateEnd}`" placement="top" v-if="scope.row.isDateLimit == true">
                  <span class="overflow-hidden">{{
                    `${scope.row.dateStart}-${scope.row.dateEnd}`
                  }}</span>
                </el-tooltip>

                <span v-else>{{ $t("terminal.noLimit") }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="isWeekLimit" :label="$t('terminal.isWeekLi')" width="140" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.isWeekLimit == true">{{
                  scope.row.weekShow
                }}</span>
                <span v-else>{{ $t("terminal.noLimit") }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('terminal.oper')" width="140" align="center">
              <template slot-scope="scope">
                <div style="display: flex">
                  <img src="@/assets/images/public/public_edit.png" style="width: 35px; height: 35px; cursor: pointer" @click="handleScEdit(scope.row, scope.$index)" />
                  <img src="@/assets/images/public/public_delete.png" style="width: 35px; height: 35px; cursor: pointer" @click="handleScDelete(scope.$index)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="s_footer">
          <el-button type="primary" round @click="newTemplate">{{
            $t("terminal.newTem")
          }}</el-button>
          <el-button type="success" round @click="saveTemplate" :disabled="sc_device == ''">{{ $t("terminal.savTem") }}</el-button>
          <el-button type="primary" round @click="confirmTemplate" :disabled="sc_device == ''">{{ $t("terminal.confirm") }}</el-button>
          <el-button type="primary" round @click="cancelTemplate">{{
            $t("terminal.cancel")
          }}</el-button>
        </div>
      </div>
      <!-- <el-dialog width="600px" title="新增定时指令" :visible.sync="innerVisible" append-to-body center
				:destroy-on-close="true">
				<div class="inner_content">
					<div class="rows">
						<span>操作指令:</span>
						<el-select v-model="sc_action">
							<el-option v-for="item in scOrderList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="rows" v-if="this.sc_action == 2">
						<span>亮度:</span>
						<div style="display: flex; align-items: center">
							<div style="width: 200px">
								<el-slider v-model="sc_light"></el-slider>
							</div>
							<span style="margin-left: 10px">{{ sc_light }}</span>
						</div>
					</div>
					<div class="rows" v-if="this.sc_action == 3">
						<span>音量:</span>
						<div style="display: flex; align-items: center">
							<div style="width: 200px">
								<el-slider v-model="sc_light"></el-slider>
							</div>
							<span style="margin-left: 10px">{{ sc_light }}</span>
						</div>
					</div>
					<div class="rows">
						<span>执行时间:</span>
						<el-time-picker v-model="sc_time" value-format="HH:mm:ss"></el-time-picker>
					</div>
					<div class="rows">
						<span>有效日期</span>
						<div style="dis_p">
							<el-radio v-model="sc_date_radio" label="1">无日期限制</el-radio>
							<el-radio v-model="sc_date_radio" label="2">指定日期</el-radio>
						</div>
					</div>
					<div class="rows" style="justify-content: space-around">
						<div>
							<el-date-picker type="date" v-model="sc_date_start" :disabled="sc_date_radio == '1'"
								value-format="yyyy/MM/dd"></el-date-picker>
							<span>至</span>
							<el-date-picker type="date" v-model="sc_date_end" :disabled="sc_date_radio == '1'"
								value-format="yyyy/MM/dd"></el-date-picker>
						</div>
					</div>
					<div class="rows">
						<span style="margin-left: 10px; margin-right: 10px">有效星期</span>
						<div>
							<el-radio v-model="sc_week_radio" label="1">无星期限制</el-radio>
							<el-radio v-model="sc_week_radio" label="2">指定星期</el-radio>
						</div>
					</div>
					<div class="rows" style="justify-content: space-around">
						<el-checkbox-group v-model="weekListSelect" :disabled="sc_week_radio == 1"
							@change="checkboxWeeksChange">
							<el-checkbox-button v-for="week in weeks" :label="week" :key="week">{{ week }}
							</el-checkbox-button>
						</el-checkbox-group>
					</div>
					<div class="rows" style="justify-content: space-around">
						<div>
							<el-button @click="innerCancel">取消</el-button>
							<el-button @click="innerConfirm" type="primary">确定</el-button>
						</div>
					</div>
				</div>
      </el-dialog>-->

      <el-dialog width="30%" :title="$t('terminal.addTem')" :visible.sync="newTemplaeVisible" append-to-body center>
        <div class="new_template_content">
          <div class="n_item">
            <span>{{ $t("terminal.temName") }}:</span>
            <div style="width: 60%">
              <el-input v-model="newTemplateName" :placeholder="$t('terminal.temTip1')"></el-input>
            </div>
          </div>
          <div class="n_item_button">
            <el-button @click="innerTemplateCancel">{{
              $t("terminal.cancel")
            }}</el-button>
            <el-button @click="innerTemplateConfirm" type="primary">{{
              $t("terminal.confirm")
            }}</el-button>
          </div>
        </div>
      </el-dialog>
    </form-dialog>
    <form-dialog :title="$t('terminal.relayOn')" :dialogVisible="relayDialog" @closeDialog="relayCloseDialog" dWidth="780px" :isAppend="true">
      <relay-control @control="relayControl"></relay-control>
    </form-dialog>
    <schedule :schduleDialog="schduleDialog" @closeSchedule="closeSchedule" :ADDEDIT="ADDEDIT" :value="schduleValue"></schedule>
    <form-dialog :title="orderName" :dialogVisible="timeZoneDialog" @closeDialog="closeTimeZone" :isAppend="true">
      <div class="flex-d-b-c" style="width: 100%; height: 100px">
        <div style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
          ">
          {{ $t("terminal.timeZoneSe") }}
          <el-select v-model="setTimeZone" @change="changeTimeZone">
            <el-option v-for="item in timezonesList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="flex-a-c" style="margin: 15px auto">
          <el-button type="primary" :disabled="currentTimeZoneId == ''" @click="timeZoneConfirm(true)" round>{{ $t("terminal.confirm") }}</el-button>
          <el-button round @click="timeZoneConfirm(false)">{{
            $t("terminal.cancel")
          }}</el-button>
        </div>
      </div>
    </form-dialog>
    <form-dialog :title="orderName" :dialogVisible="signalVisible" @closeDialog="signalConfirm(false)" :isAppend="true">
      <div class="flex-d-a-c" style="width: 100%; height: 140px">
        <div style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 80px;
          ">
          <el-radio v-model="signalValue" :label="1">
            <span style="font-size: 16px">{{ $t("terminal.hdmiSi") }}</span>
          </el-radio>
          <el-radio v-model="signalValue" :label="2">
            <span style="font-size: 16px">{{ $t("terminal.inSin") }}</span>
          </el-radio>
        </div>
        <div class="footer" style="margin: 10px auto">
          <el-button type="primary" round @click="signalConfirm(true)">{{
            $t("terminal.confirm")
          }}</el-button>
          <el-button round @click="signalConfirm(false)">{{
            $t("terminal.cancel")
          }}</el-button>
        </div>
      </div>
    </form-dialog>
    <form-dialog :title="orderName" :dialogVisible="syncPlayVisible" @closeDialog="syncPlayConfirm(false)" :isAppend="true" dWidth="420px">
      <div class="flex-d-a-c" style="font-size: 18px; height: 120px">
        <div style="height: 80px; width: 205px">
          <el-radio v-model="sync_play_status" :label="1">
            <span style="font-size: 16px">{{ $t("terminal.openMulti") }}</span>
          </el-radio>
          <div style="
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              padding-left: 40px;
              height: 60px;
            ">
            <el-radio v-model="sync_play_type" :label="2" :disabled="sync_play_status == 0">{{ $t("terminal.gps") }}</el-radio>
            <el-radio v-model="sync_play_type" :label="1" :disabled="sync_play_status == 0">{{ $t("terminal.localW") }}</el-radio>
          </div>
        </div>
        <div style="width: 205px">
          <el-radio v-model="sync_play_status" :label="0">
            <span style="font-size: 16px">{{
              $t("terminal.closeScreen")
            }}</span>
          </el-radio>
        </div>
      </div>
      <div class="flex-a-c" style="margin: 10px auto; width: 180px">
        <el-button type="primary" round @click="syncPlayConfirm(true)">{{
          $t("terminal.confirm")
        }}</el-button>
        <el-button round @click="syncPlayConfirm(false)">{{
          $t("terminal.cancel")
        }}</el-button>
      </div>
    </form-dialog>
    <form-dialog :title="orderName" :dialogVisible="scheduleRunningVisible" @closeDialog="scheduleRunConfirm(false)" :isAppend="true">
      <div class="flex-d-b-c" style="width: 100%; height: 140px">
        <div style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 80px;
          ">
          <el-radio v-model="scheduleisRun" :label="1">
            <span style="font-size: 16px">{{
              $t("terminal.openTimePlay")
            }}</span>
          </el-radio>
          <el-radio v-model="scheduleisRun" :label="2">
            <span style="font-size: 16px">{{
              $t("terminal.closeTimePlay")
            }}</span>
          </el-radio>
        </div>
        <div class="footer">
          <el-button type="primary" round @click="scheduleRunConfirm(true)">{{
            $t("terminal.confirm")
          }}</el-button>
          <el-button round @click="scheduleRunConfirm(false)">{{
            $t("terminal.cancel")
          }}</el-button>
        </div>
      </div>
    </form-dialog>
    <form-dialog :title="orderName" :dialogVisible="powerOnoffVisible" dWidth="500px" @closeDialog="powerOnoffConfirm(false)" :isAppend="true">
      <div class="flex-d-b-c" style="height: 260px">
        <div style="height: 180px; width: 100%; padding-left: 50px">
          <el-radio v-model="power_onoff_statue" :label="1">
            <span style="font-size: 16px">{{ $t("terminal.openTime") }}</span>
          </el-radio>
          <div style="
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              height: 180px;
            ">
            <div class="power-time" style="margin-top: 10px auto">
              <span>{{ $t("terminal.onTime") }}</span>
              <el-time-picker v-model="power_on_time" size="small" :disabled="power_onoff_statue !== 1"></el-time-picker>
            </div>
            <div class="power-time">
              <span>{{ $t("terminal.offTime") }}</span>
              <el-time-picker v-model="power_off_time" size="small" :disabled="power_onoff_statue !== 1"></el-time-picker>
            </div>
            <div>
              <span style="margin-left: 35px">{{
                $t("terminal.excDate")
              }}</span>
            </div>
            <div class="flex-c-c">
              <el-checkbox-group v-model="weekListSelect" size="small" @change="checkboxWeeksChange">
                <el-checkbox-button v-for="week in weeks" :label="week" :key="week" :disabled="power_onoff_statue !== 1">{{ `${$t(`${week}`)}` }}</el-checkbox-button>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div style="width: 100%; padding-left: 50px; margin: 10px auto">
          <el-radio v-model="power_onoff_statue" :label="0">
            <span style="font-size: 16px">{{ $t("terminal.closeTime") }}</span>
          </el-radio>
        </div>
      </div>
      <div class="flex-a-c" style="width: 100%; position: relative">
        <div style="
            width: 220px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
          ">
          <el-button type="primary" round @click="powerOnoffConfirm(true)">{{
            $t("terminal.confirm")
          }}</el-button>
          <el-button round @click="powerOnoffConfirm(false)">{{
            $t("terminal.cancel")
          }}</el-button>
        </div>
        <span style="position: absolute; right: 0; bottom: -10px">{{
          $t("terminal.onlyG")
        }}</span>
      </div>
    </form-dialog>
    <form-dialog :title="orderName" :dialogVisible="batchUpdateVisible" @closeDialog="updateConfirm" :isAppend="true" dWidth="900px">
      <batch-update :tableData="batchData" @closeDialog="updateConfirm"></batch-update>
      <div class="formd-footer"></div>
    </form-dialog>
    <!-- <msg-dialog :title="orderName" :dialogVisible="cloudMonitorTime" @closeDialog="closeMonitorTime" :modalAppend="false">
      <div><el-checkbox v-model="isOpenCloudMonitor">启用云平台看护</el-checkbox></div>
      <div style="margin:8px 16px">
        监控云平台连接状态，当连接断开
        <el-select v-model="selectTime" placeholder="请选择" size="mini" style="width:100px">
          <el-option v-for="item in cloudMonitorTimeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        时，盒子自动尝试重启再登录。
      </div>
    </msg-dialog> -->
    <form-dialog :title="orderName" :dialogVisible="cloudMonitorTime" @closeDialog="closeMonitorTime" :isAppend="true">
      <div><el-checkbox v-model="isOpenCloudMonitor">{{$t('ctch4')}}</el-checkbox></div>
      <div style="margin:8px 16px">
        监控云平台连接状态，当连接断开
        <el-select v-model="selectTime" placeholder="请选择" size="mini" style="width:100px">
          <el-option v-for="item in cloudMonitorTimeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        时，盒子自动尝试重启再登录。
      </div>
      <div class="flex-a-c" style="width: 160px; margin: 0 auto">
        <el-button round @click="closeMonitorTime(false)">{{ $t("terminal.cancel") }}</el-button>
        <el-button type="primary" round @click="closeMonitorTime(true)">{{ $t("terminal.confirm") }}</el-button>
      </div>
    </form-dialog>
    <!-- <msg-dialog :dialogVisible="logsDialog" @closeDialog="logsConfirm" :buttonName="['开启上传','关闭上传']" :title="`${orderName}`" :modalAppend="false">
      <div style="width: 100%;height: 60px;text-align: center;padding-top: 20px;font-size: 16px;">
        设置日志上传
      </div>
    </msg-dialog> -->

    <form-dialog :dialogVisible="logsDialog" @closeDialog="logsConfirm" :buttonName="[$t('ctch6'),$t('ctch7')]" :title="`${orderName}`" :isAppend="true">
      <div style="width: 100%;height: 60px;text-align: center;padding-top: 20px;font-size: 16px;">
        设置日志上传
      </div>
      <div class="flex-a-c" style="width: 160px; margin: 0 auto">
        <el-button type="primary" round @click="logsConfirm(true)">{{$t('ctch6')}}</el-button>
        <el-button type="danger" plain round @click="logsConfirm(false)">{{$t('ctch7')}}</el-button>
      </div>
    </form-dialog>

    <form-dialog :title="orderName" :dialogVisible="sendUrgentMsgDv" @closeDialog="emergencyOrder" :isAppend="true" dWidth="600px">
      <ul>
        <li class="flex-c e-o-li" style="margin-top: 0px;">
          <div class="title">{{$t('ctch8')}}</div>
          <div>
            <el-checkbox v-model="emergencyOrderInfo.isFull" @change="changeIsFull"></el-checkbox>
          </div>
        </li>
        <li class="flex-c e-o-li" style="margin-top: 0px;" v-if="sendUrgentMsgDv">
          <div class="title flex-d-b-c" style="height: 90px;align-items: flex-end ">
            <div>{{$t('ctch9')}}</div>
            <div>
              <el-dropdown @command="selectUrgentText">
                <span class="el-dropdown-link">
                  {{$t('ctch10')}}
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 200px;overflow-y: auto;">

                  <el-dropdown-item v-for="ut in urgentTextList" :key="ut.id" :command="ut.id">{{ ut.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div></div>
          </div>
          <div>
            <div>
              <el-input style="width: 430px" type="textarea" :rows="2" :placeholder="$t('ctch11')" v-model="emergencyOrderInfo.text">
              </el-input>
            </div>
            <ul class="flex-b-c" style="margin-top: 8px;">
              <li class="flex-b-c" style="width: 170px;">{{$t('ctch12')}} :
                <!-- <el-select v-model="emergencyOrderInfo.textSize" placeholder="请选择" size="mini" style="width: 100px;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-select> -->
                <div style="width: 100px;"><set-font-size @setFontSize="setFontSize" :defaultSize="emergencyOrderInfo.textSize"></set-font-size></div>
              </li>
              <li class="flex-b-c">
                <span>{{$t('ctch13')}} : </span>
                <el-color-picker v-model="emergencyOrderInfo.textColor" :predefine="predefineColors" show-alpha size="mini"></el-color-picker>
              </li>
              <!-- <li>文字颜色 : <el-select v-model="emergencyOrderInfo.textColor" placeholder="请选择" size="mini" style="width: 100px;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </li> -->
              <li class="flex-b-c">
                <span>{{$t('ctch14')}} : </span>
                <el-color-picker v-model="emergencyOrderInfo.bgColor" :predefine="predefineColors" show-alpha size="mini"></el-color-picker>
              </li>
              <!-- <li>文字背景 : <el-select v-model="emergencyOrderInfo.bgColor" placeholder="请选择" size="mini" style="width: 100px;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </li> -->
            </ul>
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">字体选择</div>
          <div>
            <el-select v-model="emergencyOrderInfo.enName" :placeholder="$t('ctch19')" size="mini" style="width: 110px;">
              <el-option v-for="item in fontFamily" :key="item.key" :label="item.key" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">{{$t('ctch15')}}</div>
          <div>
            <el-time-picker v-model="emergencyOrderInfo.playTime" :picker-options="{
      selectableRange: '00:00:00 - 23:59:59'
    }" :placeholder="$t('ctch16')" size="mini" style="width: 110px;" :clearable="false">
            </el-time-picker>
          </div>
        </li>
        <li class="flex-c e-o-li" v-if="false">
          <div class="title">{{$t('ctch17')}}</div>
          <div>
            <el-select v-model="emergencyOrderInfo.playRank" :placeholder="$t('ctch19')" size="mini" style="width: 110px;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="flex-c e-o-li" v-if="false">
          <div class="title">{{$t('ctch18')}}</div>
          <div>
            <el-select v-model="emergencyOrderInfo.playRank" placeholder="请选择" size="mini" style="width: 110px;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">{{$t('ctch18')}}</div>
          <div>
            <el-radio v-model="emergencyOrderInfo.mute" label="0">不处理</el-radio>
            <el-radio v-model="emergencyOrderInfo.mute" label="1">播放时静音</el-radio>
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">滚动翻页</div>
          <div>
            <el-radio v-model="emergencyOrderInfo.scrollDir" label="2">滚动</el-radio>
            <el-radio v-model="emergencyOrderInfo.scrollDir" label="5">翻页</el-radio>
          </div>
        </li>
        <li class="flex-c e-o-li" v-if="emergencyOrderInfo.scrollDir == 2">
          <div class="title">滚动速度</div>
          <div>
            <el-select v-model="emergencyOrderInfo.scrollSpeed" placeholder="请选择" size="mini" style="width: 110px;">
              <el-option v-for="item in [1,2,3,4,5,6,7,8,9,10]" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="flex-c e-o-li" v-if="emergencyOrderInfo.scrollDir == 5">
          <div class="title">翻页时间</div>
          <div>
            <el-input-number v-model="emergencyOrderInfo.turnPageTime" controls-position="right" :min="1" size="mini" style="width: 110px;"></el-input-number> 秒
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">背景图片</div>
          <div>
            <el-button type="primary" plain size="mini" @click="addUrgentImg">选择图片</el-button>
            (所选图片必须已经随节目上传到终端)
          </div>
        </li>

        <!-- <li class="flex-c e-o-li">
          <div class="title">播放时间(秒)</div>
          <div>
            <el-select size="small" v-model="emergencyOrderInfo.playTime" allow-create filterable @change="userDefinedPlayTime" placeholder="请选择">
              <el-option v-for="item in playTimeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">播报优先级</div>
          <div>
            <el-select size="small" v-model="emergencyOrderInfo.playRank" placeholder="请选择">
              <el-option v-for="item in playRankOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="flex-c e-o-li">
          <div class="title">显示类型</div>
          <div>
            <el-select size="small" v-model="emergencyOrderInfo.playType" placeholder="请选择">
              <el-option v-for="item in playTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </li> -->
      </ul>
      <div class="formd-footer flex-a-c">
        <el-button type="primary" round size="small" @click="sendEmergencyOrder('on')">{{$t('ctch20')}}</el-button>
        <!-- <el-button type="danger" plain round size="small" @click="sendEmergencyOrder('off')">紧急取消</el-button> -->
        <!-- <el-button round size="small" @click="sendEmergencyOrder('openMode')">模式播放</el-button> -->
        <el-button round size="small" @click="emergencyOrder">{{$t('ctch21')}}</el-button>
      </div>
    </form-dialog>

    <msg-dialog :dialogVisible="offUrgentMsgDv" @closeDialog="offUrgentMsgDialog" :title="`${orderName}`" :modalAppend="false">
      <div class="flex-a-c e-o-li">
        {{`${$t('ctch22')}${orderName}？`}}
      </div>
    </msg-dialog>

    <msg-dialog :dialogVisible="addUrgentImgDv" @closeDialog="addUrgentImgDialog" :title="`${orderName}图片`" :modalAppend="false" dWidth="500px">
      <div class="flex-a-c" style="width: 100%;height: 300px;">
        <ul class="infinite-list flex-b-c-w" v-infinite-scroll="mediaLoding" style="width: 100%;height: 100%;overflow:auto">
          <li v-for="m in mediaList" :key="m.id" class="infinite-list-item media-list-item" :class="{'media-list-item-activate':mediaActivate === m.id}" @click="()=>{mediaActivate=m.id}" v-show="m.type ===2">
            <media-item :media="m" />
          </li>
        </ul>
      </div>
    </msg-dialog>

    <!-- <form-dialog :title="orderName" :dialogVisible="urgentTemplate" @closeDialog="urgentTemplateConfirm" :isAppend="true">
      <div class="flex-c e-o-li">
        <div class="title">版式选择</div>
        <div>
          <el-select size="small" v-model="urgentProgramsValue" placeholder="请选择">
            <el-option v-for="item in urgentProgramsList" :key="item.id" :label="item.content" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </form-dialog> -->

    <msg-dialog :dialogVisible="urgentTemplate" @closeDialog="urgentTemplateConfirm" :title="`${orderName}`" :modalAppend="false">
      <div class="flex-c e-o-li">
        <div class="title">{{$t('ctch23')}}</div>
        <div>
          <el-select size="small" v-model="urgentProgramsId" :placeholder="$t('ctch24')">
            <el-option v-for="item in urgentProgramsList" :key="item.id" :label="item.content" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </msg-dialog>

    <msg-dialog :dialogVisible="programPlayModel" @closeDialog="programPlayModelConfirm" :title="`${orderName}`" :modalAppend="false">
      <div class="flex-c e-o-li">
        <div class="title">{{$t('ctch25')}}</div>
        <div>
          <el-select size="small" v-model="emergencyOrderInfo.modeIndex" :placeholder="$t('ctch24')">
            <el-option v-show="item.value" v-for="item in playRankOptions" :key="item.value" :label="`${$t('ctch26')}${item.label}`" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </msg-dialog>
    <msg-dialog :dialogVisible="streamingMediaDv" @closeDialog="streamingMediaConfirm" :title="`${orderName}`" :modalAppend="false">
      <div class="flex-c e-o-li">
        <el-checkbox v-model="streamingMedia.open" @change="changeIsFull">{{$t('ctch27')}}</el-checkbox>
      </div>
      <div class="flex-c e-o-li">
        <div class="flex-a-c" style="flex-wrap:wrap">
          <el-input :placeholder="$t('ctch28')" v-model="streamingMedia.x" size="mini" style="width: 120px;margin: 8px 0px;">
            <template slot="prepend">X</template>
          </el-input>
          <el-input :placeholder="$t('ctch28')" v-model="streamingMedia.y" size="mini" style="width: 120px;margin: 8px 0px;">
            <template slot="prepend">Y</template>
          </el-input>
          <el-input :placeholder="$t('ctch28')" v-model="streamingMedia.width" size="mini" style="width: 120px;margin: 8px 0px;">
            <template slot="prepend">W</template>
          </el-input>
          <el-input :placeholder="$t('ctch28')" v-model="streamingMedia.height" size="mini" style="width: 120px;margin: 8px 0px;">
            <template slot="prepend">H</template>
          </el-input>
        </div>
      </div>
      <div class="flex-c e-o-li">
        <el-input :placeholder="$t('ctch29')" v-model="streamingMedia.url" size="mini">
          <template slot="prepend">{{$t('ntch01')}}</template>
        </el-input>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
const orderTimeLimit = 5;
const TP_DET_URL = "/admin/device/getScheduleTemplateDetail";
//const generalCommand = '/admin/command/generalCommand';
//const SC_COM_URL = "/admin/device/scheduleCommands";
//const weekList = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
const weekList = ["terminal.Sunday", "terminal.Monday", "terminal.Tuesday", "terminal.Wednesday", "terminal.Thursday",
  "terminal.Friday", "terminal.Saturday"
];

const fontFamily = [
  { key: '宋体', value: 'SIMSUN' },
  { key: '仿宋', value: 'SIMFANG' },
  { key: '华文中宋', value: 'STZHONGS' },
  { key: '楷体', value: 'SIMKAI' },
  { key: '黑体', value: 'SIMHEI' },
  { key: 'Arial', value: 'ARIAL' },
];

const cloudMonitorTimeList = [{
  value: '10',
  label: '10分钟'
}, {
  value: '20',
  label: '20分钟'
}, {
  value: '30',
  label: '30分钟'
}, {
  value: '60',
  label: '60分钟'
}, {
  value: '120',
  label: '120分钟'
}]
const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1;
const date = now.getDate();
const start_time =
  year +
  "/" +
  (month < 10 ? "0" + month : month) +
  "/" +
  (date < 10 ? "0" + date : date);
const hour = now.getHours();
const minutes = now.getMinutes();
const seconds = now.getSeconds();
const nowtime = hour + ":" + minutes + ":" + seconds;
const end_time = start_time;
let weekObj = {
  周日: Math.pow(2, 0),
  周一: Math.pow(2, 1),
  周二: Math.pow(2, 2),
  周三: Math.pow(2, 3),
  周四: Math.pow(2, 4),
  周五: Math.pow(2, 5),
  周六: Math.pow(2, 6),
};
import timezones from "@static/data/timezones";
import DelDialog from "@/components/basics/DelDialogConfirm";
import { uriEncode } from "@/assets/scripts/uriEncode";
import { getDeviceInfo } from "@/assets/scripts/getDeviceInfo";

import { dateFormat, timeFormatting, msFormatting } from "@/assets/scripts/dateFormatting";
import FormDialog from "@/components/basics/FormDialogConfirm";
import MsgDialog from "@/components/basics/MsgDialog";
import RelayControl from "./item/RelayControl";
import Schedule from "./item/Schedule";
import BatchUpdate from "./item/BatchUpdate.vue"
import {
  powerAndCard,
  daysWeek,
  sendCommandKp
} from "@/assets/scripts/publicFunction.js";
import {
  runStateInfo
} from "@/assets/scripts/runState";
import {
  changeDeviceStateName
} from "@/assets/scripts/changeDeviceStateName";
import SetFontSize from "@/components/schedule/windows/children/AttrList/children/SetFontSize";
import { rgbaToHex } from '@/assets/scripts/rgbaAndHex.js';
import superClone from '@/assets/scripts/superClone.js';
import { hmsToSec } from "@/assets/scripts/publicFunction";
import MediaItem from '@/components/basics/MediaItem.vue';
import XLSX from 'xlsx'
import Vue from 'vue'

const urgentInfo = {
  isFull: false,
  text: "紧急消息",
  playTime: new Date("2000-12-12 00:00:00"),
  playRank: parseInt(Vue.$cookies.get("priority")) + 10,
  playType: "roll",
  // modeIndex: 1,
  textSize: 80,
  textColor: 'rgba(255, 0, 0, 1)',
  bgColor: 'rgba(255, 255, 255, 1)',
  bgMd5AndLength: "",
  turnPageTime: 5,
  scrollSpeed: 5,
  scrollDir: '2',
  mute: '0',
  enName: 'SIMSUN',
  x: 0,
  y: 960,
  width: 1920,
  height: 120,
};

const predefineColors = [
  '#FFFF00',
  '#FFFFFF',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#000000',
  '#FF00FF',
  '#00FFFF'
];

export default {
  name: "HandleOrder",
  components: {
    DelDialog,
    MsgDialog,
    FormDialog,
    RelayControl,
    Schedule,
    BatchUpdate,
    SetFontSize,
    MediaItem
  },
  props: {
    btType: {
      type: String, //按钮类型
      default: ''
    },
    orderType: {
      type: String //命令类型
    },
    orderName: {
      type: String //命令名称，按钮名称
    },
    isList: {
      type: Boolean //true列表, false图表
    },
    panduan: {
      type: Boolean //列表模式下是否全选,true全选
    },
    itemPanduan: {
      type: Boolean //列表模式下是否全选,true全选
    },
    noCheckList: {
      type: Array //列表模式下没有选择的
    },
    itemsNoselectList: {
      type: Array //图表模式下没有选择的
    },
    listSeletList: {
      type: Array //列表选择的数据
    },
    itemsDataList: {
      type: Array //图表选择的数据
    },
    currentItem: {
      type: Number
    },
    current: {
      type: Number
    }
  },
  data() {
    return {
      predefineColors,
      device_select_mode: '',
      devices_info: [],
      logsDialog: false,
      schduleDialog: false,
      ADDEDIT: 'ADD',
      schduleValue: null,
      inner_edit_index: null,
      delDialogVisible: false,
      scheduleDialog: false,
      relayDialog: false,
      cloudMonitorTime: false,
      cloudMonitorTimeList: cloudMonitorTimeList,
      selectTime: '20',
      isOpenCloudMonitor: false,
      lightDialog: false,
      timeZoneDialog: false, //时区设置
      setTimeZone: "",
      currentTimeZoneId: '',
      sendUrgentMsgDv: false,
      offUrgentMsgDv: false,
      addUrgentImgDv: false,
      addUrgentImgLoding: false,
      mediaList: [],
      mediaCurrent: 0,
      mediaPage: 1,
      mediaActivate: '',
      emergencyOrderInfo: superClone(urgentInfo),
      streamingMedia: {
        url: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        open: true
      },
      programPlayModel: false,
      signalVisible: false, //信号切换
      signalValue: 1,
      urgentTemplate: false,
      streamingMediaDv: false,
      urgentProgramsList: [],
      urgentTextList: [],
      urgentProgramsId: -1,
      syncPlayVisible: false, //多屏同步
      sync_play_status: 1, //1打开0关闭
      sync_play_type: 2, //1网络同步2gps同步

      scheduleRunningVisible: false, //定时播放
      scheduleisRun: 1,

      powerOnoffVisible: false, //定时开关机
      batchUpdateVisible: false, //批量升级


      batchData: [],

      power_onoff_statue: 1,
      power_on_time: new Date(2022, 9, 10, 8, 0),
      power_off_time: new Date(2022, 9, 10, 20, 30),
      power_week_limit: 0,

      newTemplaeVisible: false,
      innerVisible: false,
      sc_device: '',
      order_now_time: null,
      orderTime: null,
      sc_light: 50,
      sc_time: nowtime,
      sc_date_start: start_time,
      sc_date_end: end_time,
      weeks: weekList,
      weekListSelect: [],
      sc_table_data: [],
      schedules_option: [],
      timezonesList: timezones, //时区列表
      loading: false,
      sc_date_radio: "1",
      sc_week_radio: "1",
      sc_action: 2,
      scOrderList: [
        { value: 2, label: "亮度调节", },
        { value: 3, label: "音量调节", },
        { value: 4, label: "关闭屏幕", },
        { value: 5, label: "开启屏幕", },
      ],
      lightForm: {
        value: 50
      },
      newTemplateName: "",
      percent: 0,
      upType: "1",
      validWeek: 0,
      feedback: [],
      playTimeOptions: [
        { value: 10, label: "10", },
        { value: 20, label: "20", },
        { value: 30, label: "30", },
        { value: 60, label: "60", },
      ],
      playRankOptions: [],
      playTypeOptions: [
        { value: 'full', label: "全屏显示", },
        { value: 'roll', label: "滚动显示", },
      ],
      options: [{
        value: '1',
        label: '选项1'
      }, {
        value: '2',
        label: '选项2'
      }],
      fontFamily
    }
  },
  methods: {
    //如果commanType 为其他 data直接传递一个对象即可
    async invokeMethodToKP(methodName, methodParams, isGetResult = false, commanType = "invoke_method") {
      let data = {}
      if (commanType == "invoke_method") {
        data = {
          methodName,
          methodParams
        }
      } else {
        data = methodParams
      }
      let result = await sendCommandKp(this.device_select_mode, this.devices_info, 'set', data, commanType)
      if (isGetResult) {
        let ids = [];
        result.result.forEach(ele => {
          ids.push(ele.id);
        })
        this.getDcinfo(ids, result);
      }
    },
    closeTimeZone() {
      this.timeZoneDialog = false;
    },
    changeTimeZone(val) {
      this.currentTimeZoneId = val;
    },
    // sendOrderToDevice(methodName, data) {
    // 	this.$http.post(generalCommand, {
    // 		device_select_mode: this.device_select_mode,
    // 		devices_info: uriEncode(this.devices_info),
    // 		request_type: 'set',
    // 		commands_info: uriEncode([{
    // 			type: "invoke_method",
    // 			data: {
    // 				methodName,
    // 				methodParams: data
    // 			}
    // 		}]),
    // 	}, data => {
    // 		let ids = [];
    // 		data.result.forEach((ele) => {
    // 			ids.push(ele.id);
    // 		})
    // 		this.getDcinfo(ids, data);
    // 	})
    // },
    timeZoneConfirm(isConfirm) {
      if (isConfirm) {
        this.invokeMethodToKP('setTimeZoneId', {
          timeZoneId: this.currentTimeZoneId
        }, true)
      }
      this.currentTimeZoneId = '';
      this.setTimeZone = '';
      this.timeZoneDialog = false;
    },
    signalConfirm(isConfirm) {
      isConfirm && this.invokeMethodToKP('setSignalInput', {
        input: this.signalValue
      }, true)
      this.signalValue = 1;
      this.signalVisible = false;
    },
    syncPlayConfirm(isConfirm) {
      isConfirm && this.invokeMethodToKP('setSyncPlay', {
        status: this.sync_play_status,
        type: this.sync_play_type
      }, true)
      this.sync_play_status = 1;
      this.sync_play_type = 2;
      this.syncPlayVisible = false;
    },
    scheduleRunConfirm(isConfirm) {
      isConfirm && this.invokeMethodToKP('scheduleRunning', {
        boolRun: this.scheduleisRun === 1 ? true : false,
      }, true)
      this.scheduleisRun = 1;
      this.scheduleRunningVisible = false;
    },
    powerOnoffConfirm(isConfirm) {
      let data = {
        onTime: timeFormatting(this.power_on_time),
        offTime: timeFormatting(this.power_off_time),
        weekLimit: parseInt(this.validWeek, 2),
        status: this.power_onoff_statue
      }
      isConfirm && this.invokeMethodToKP('setPowerOnOff', data, true);
      this.powerOnoffVisible = false;
      this.power_on_time = new Date(2022, 9, 10, 8, 0);
      this.power_off_time = new Date(2022, 9, 10, 20, 30);
      this.validWeek = 0;
      this.weekListSelect = [];
      this.power_onoff_statue = 1;
    },
    closeSchedule(val) {
      if (typeof (val.validWeek) === 'string') {
        val.validWeek = parseInt(val.validWeek, 2);
      }
      if (val !== 'cancel') {
        if (val.action == 7 || val.action == 8) {
          val.pcList = powerAndCard(val.value)
        }
        if (this.inner_edit_index == null) {
          this.sc_table_data.push(val);
        } else {
          this.$set(this.sc_table_data, this.inner_edit_index, val);
        }
      }
      this.inner_edit_index = null;
      this.schduleDialog = false;
      this.schduleValue = null;
      this.ADDEDIT = 'ADD';
    },
    lightCancel() {
      this.lightDialog = false;
    },
    confirmLight() {
      if (this.lightForm.value < 0 || this.lightForm.value > 100) {
        this.$msg({
          type: 'warning',
          message: this.$t('ctch38')
        })
      } else {
        this.setBrightAndLight();
        this.lightDialog = false;
      }
    },
    lightCloseDialog() {
      this.lightDialog = false;
    },
    scheduleCloseDialog() {
      this.sc_device = "";
      this.sc_table_data = [];
      this.scheduleDialog = false;
    },
    relayControl(isConfirm, isOpen, status) {
      if (isConfirm) {
        console.log(isOpen, status);
        let isOpenList = isOpen.split("");
        let statusList = status.split("");
        let off = isOpenList.map((value, index) => {
          return value == '1' && statusList[index] == '0' ? 1 : 0;
        }).join("");
        let on = status;

        this.invokeMethodToKP('setAllRelay', {
          status: parseInt(off, 2),
          isOpen: 0
        }, true);
        this.invokeMethodToKP('setAllRelay', {
          status: parseInt(on, 2),
          isOpen: 1
        }, true);
      }
      this.relayDialog = false;
    },
    relayCloseDialog() {
      this.relayDialog = false;
    },
    getScheduleTemplateDetail() {
      this.loading = true;
      this.$http.post(
        TP_DET_URL, {
        id: this.sc_device,
      },
        (data) => {
          this.sc_table_data = JSON.parse(data.data);
          this.sc_table_data.forEach(ele => {
            ele.weekShow = daysWeek(ele.validWeek);
          })
          this.template_name = data.name;
          this.loading = false;
        }
      );
    },
    delete_template(id) {
      this.$http.post(
        "/admin/device/delScheduleTemplate", {
        id,
      }, () => {
        this.sc_device = "";
        this.sc_table_data = [];
        this.getTemplate();
      }
      );
    },
    addTimeOrder() {
      this.inner_edit_index = null;
      this.ADDEDIT = 'ADD';
      this.schduleDialog = true;
    },
    handleScEdit(val, index) {
      console.log(val);
      this.schduleValue = val;
      this.ADDEDIT = 'EDIT';
      this.inner_edit_index = index;
      this.schduleDialog = true;
    },
    handleScDelete(index) {
      this.sc_table_data.splice(index, 1);
    },
    newTemplate() {
      this.newTemplaeVisible = true;
    },
    saveTemplate() {
      const group_id = this.$cookies.get("group_id");
      this.loading = true;
      this.$http.post(
        "/admin/device/editScheduleTemplate", {
        group_id: group_id,
        id: this.sc_device,
        name: this.template_name,
        data: uriEncode(this.sc_table_data),
      },
        (data) => {
          console.log(data);
          this.$msg({
            message: this.$t('ctch39'),
            type: "success",
          });
          this.getScheduleTemplateDetail();
          this.loading = false;
        }
      );
    },
    confirmTemplate() {
      this.sc_table_data.forEach((ele) => {
        delete ele.id;
        delete ele.name;
        delete ele.weekShow;
      });
      this.invokeMethodToKP('schedule_setting', this.sc_table_data, true, "schedule_setting");
      this.scheduleDialog = false;
    },
    cancelTemplate() {
      this.scheduleDialog = false;
    },
    checkboxWeeksChange() {
      let weekB = 0;
      this.weekListSelect.forEach((week) => {
        weekB += weekObj[week];
      });
      this.validWeek = weekB.toString(2);
    },
    innerTemplateCancel() {
      this.newTemplateName = "";
      this.newTemplaeVisible = false;
    },
    innerTemplateConfirm() {
      const group_id = this.$cookies.get("group_id");
      this.$http.post(
        "/admin/device/addScheduleTemplate", {
        group_id: group_id,
        name: this.newTemplateName,
        data: uriEncode([]),
      }, date => {
        if (date == 999999997) {
          this.$msg({
            type: 'warning',
            message: this.$t('ctch40')
          })
        } else {
          this.getTemplate();
          this.sc_device = Number(date);
          this.loading = true;
          this.$http.post(
            TP_DET_URL, {
            id: date,
          },
            (data) => {
              this.sc_table_data = JSON.parse(data.data);
              this.sc_table_data.forEach(ele => {
                if (ele.action == 7 || ele.action == 8) {
                  ele.pcList = powerAndCard(ele.value)
                }
              })
              this.template_name = data.name;
              this.loading = false;
            }
          );
          this.newTemplaeVisible = false;
          this.newTemplateName = "";
        }
      }
      );
    },
    getTemplate() {
      const group_ids = sessionStorage.getItem('group_ids');
      this.$http.post(
        "/admin/device/getScheduleTemplateList", {
        group_ids: group_ids,
      },
        (data) => {
          this.schedules_option = data;
        }
      );
    },
    handleOrderType(type) {
      [this.device_select_mode, this.devices_info] = getDeviceInfo(this.isList, this.panduan, this.noCheckList,
        this.listSeletList, this.itemPanduan, this.itemsNoselectList, this.itemsDataList)
      switch (type) {
        case "schedule_setting":
          this.getTemplate();
          this.scheduleDialog = true;
          break;
        case "offscreen_control":
        case "onscreen_control":
        case 'restart_control':
        case 'capture_save':
        case 'schedule_back':
          this.delDialogVisible = true;
          break;
        case 'setting/voice':
        case 'setting/bright':
          this.lightDialog = true;
          break;
        case 'relay_control':
          this.relayDialog = true;
          break;
        case 'set_cloud_monitor_time':
          this.cloudMonitorTime = true;
          break;
        case 'time_zone_setting':
          this.timeZoneDialog = true;
          break;
        case 'signal_change':
          this.signalVisible = true;
          break;
        case 'sync_play':
          this.syncPlayVisible = true;
          break;
        case 'schedule_running':
          this.scheduleRunningVisible = true;
          break;
        case 'power_onoff':
          this.powerOnoffVisible = true;
          break;
        case 'up_logs':
          this.logsDialog = true;
          break;
        // case 'send_text_info':
        //   this.sendUrgentMsgDv = true;
        //   break;
        case 'send_text_info':
          this.getUrgentText();
          this.sendUrgentMsgDv = true;
          break;
        case 'cancel_text_info':
          this.offUrgentMsgDv = true;
          break;
        case 'program_play_by_name':
          this.getUrgentPrograms();
          this.urgentTemplate = true;
          break;
        case 'streaming_media':
          this.streamingMediaDv = true;
          break;


        case "batch_update":
          this.$http.post("/admin/device/selectList", {
            device_select_mode: this.device_select_mode,
            devices_info: uriEncode(this.devices_info),
            group_ids: sessionStorage.getItem('group_ids')
          }, data => {
            this.batchData = data;
            this.batchData.forEach((ele) => {
              ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
              ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
            });
          })
          this.batchUpdateVisible = true;
          break;
      }
    },
    updateConfirm() {
      this.batchUpdateVisible = false;
    },
    closeMonitorTime(isConfirm) {
      if (isConfirm) {
        // console.log(isConfirm);
        // console.log(this.selectTime);

        this.invokeMethodToKP('set_cloud_reboot_status', {
          status: this.isOpenCloudMonitor ? 1 : 0
        }, true)
        this.invokeMethodToKP('set_cloud_monitor_time', {
          time: this.selectTime
        }, true)
      }
      this.cloudMonitorTime = false;
    },
    isDropdown(type) {
      switch (type) {
        case 'send_text_info':
        case 'program_play_by_name':
          return false;
        default:
          return true;
      }
    },
    handleTimeLimit(type) {

      switch (type) {
        case 'device_export':
          this.deviceExport();
          return;
        default:
          break;
      }

      if (this.isList == true) {
        if (this.panduan == false) {
          if (this.listSeletList.length == 0) {
            this.$msg({
              message: this.$t('terminal.noDeviceSelected'),
              type: "warning",
            });
          } else {
            this.handleOrderType(type);
          }
        } else {
          if (this.noCheckList.length == this.current) {
            this.$msg({
              message: this.$t('terminal.noDeviceSelected'),
              type: "warning",
            });
          } else {
            this.handleOrderType(type);
          }
        }
      } else {
        if (this.itemPanduan == true) {
          if (this.itemsNoselectList.length == 0 && this.itemsNoselectList.length != this.currentItem) {
            this.handleOrderType(type);
          } else if (this.itemsNoselectList.length == this.currentItem) {
            this.$msg({
              message: this.$t('terminal.noDeviceSelected'),
              type: "warning",
            });
          } else {
            this.handleOrderType(type);
          }
        } else {
          if (this.itemsDataList.length == 0) {
            this.$msg({
              message: this.$t('terminal.noDeviceSelected'),
              type: "warning",
            });
          } else {
            this.handleOrderType(type);
          }
        }
      }
    },
    deviceExport() {
      this.$http.post("/admin/device/selectList", { device_select_mode: 'all', group_ids: sessionStorage.getItem('group_ids') }, (res) => {
        const dList = res.map(d => {
          const { last_heartbeat, total_uptime, run_state } = d;
          const tu = new Date(last_heartbeat * 1000);
          d.last_heartbeat = last_heartbeat ? `${dateFormat(tu)}  ${timeFormatting(tu)}` : '/';
          d.total_uptime = total_uptime ? msFormatting(total_uptime) : '/';
          d.run_state = { 0: '离线', 1: '播放', 2: '休眠', 3: '登录', 4: '下载', 5: '停止', 6: '重启', 7: '开屏', 8: '关屏' }[run_state];
          return d;
        });

        let xlsxList = dList.map(d => {
          const { name, sn, size_remark, group_name, last_heartbeat, total_uptime, run_state } = d;
          return [name, sn, size_remark, group_name, last_heartbeat, total_uptime, run_state]
        })
        const data = [
          ['设备名称', 'SN', '分辨率', '组织结构', '心跳时间', '运行时间', '运行状态'],
          ...xlsxList
        ];

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        let d = new Date();
        XLSX.writeFile(wb, `设备统计_${dateFormat(d)}  ${timeFormatting(d)}.xlsx`);
        this.$message({ type: 'success', message: '设备统计导出成功，稍后自动下载!' });
      });
    },
    delCloseDialog(isConfirm) {
      if (isConfirm) {
        switch (this.orderType) {
          case 'schedule_back':
            this.invokeMethodToKP('schedule_back', {}, true);
            break;
          default:
            this.handleOrder(this.orderType);
            break;
        }
      }
      this.delDialogVisible = false;
    },
    logsConfirm(isConfirm) {
      if (isConfirm === true) {
        this.invokeMethodToKP('set_media_log', { status: 1 }, true)
      }
      if (isConfirm === false) {
        this.invokeMethodToKP('set_media_log', { status: 0 }, true)
      }
      this.logsDialog = false;
    },
    emergencyOrder(isConfirm) {
      if (isConfirm === true) {
        // this.invokeMethodToKP('set_media_log', { status: 1 }, true)
      }
      if (isConfirm === false) {
        // this.invokeMethodToKP('set_media_log', { status: 0 }, true)
      }
      this.sendUrgentMsgDv = false;
    },
    changeIsFull(val) {
      if (val) {
        // 全屏
        this.emergencyOrderInfo = {
          ...this.emergencyOrderInfo, ...{
            x: 0, y: 0, width: 1920, height: 1080,
          },
          scrollDir: '5',
          turnPageTime: 30,
          mute: '1',
          textSize: 80,
          textColor: 'rgba(255, 0, 0, 1)',
          bgColor: 'rgba(0, 0, 255, 1)',
          playRank: parseInt(this.$cookies.get("priority"))
        };
      } else {
        // 滚动
        this.emergencyOrderInfo = {
          ...this.emergencyOrderInfo, ...{
            x: 0, y: 960, width: 1920, height: 120,
          },
          scrollDir: '2',
          mute: '0',
          scrollSpeed: 5,
          textSize: 80,
          textColor: 'rgba(255, 0, 0, 1)',
          bgColor: 'rgba(255, 255, 255, 1)',
          playRank: parseInt(this.$cookies.get("priority")) + 10
        };
      }

      // console.log(this.emergencyOrderInfo);
    },
    offUrgentMsgDialog(isConfirm) {
      if (isConfirm === true) {
        this.invokeMethodToKP('cancelTextInfo', {}, true)
        this.$message({ type: 'success', message: this.$t('ctch41') });
      }
      this.offUrgentMsgDv = false;
    },
    addUrgentImgDialog(isConfirm) {
      if (isConfirm === true && this.mediaActivate !== '') {
        let media = this.mediaList.find(m => m.id === this.mediaActivate)
        this.emergencyOrderInfo.bgMd5AndLength = `${media.md5}-${media.ref_size}`;
        this.emergencyOrderInfo.bgColor = 'rgba(0, 0, 0, 0)';
      }
      this.mediaList = [];
      this.mediaActivate = '';
      this.addUrgentImgDv = false;
    },
    addUrgentImg() {
      this.addUrgentImgDv = true;
      this.addUrgentImgLoding = true;
      this.getMaterialList(1);
    },
    mediaLoding() {
      if (this.mediaPage * 12 < this.mediaCurrent) {
        this.mediaPage++;
        this.getMaterialList(this.mediaPage);
      }
      return;
    },
    getMaterialList(page) {
      let media = {
        dir_id: this.$cookies.get("group_id"),
        limit: 12,
        page,
      }
      this.$http.post("/admin/material/list", media, data => {
        this.mediaList = data.data ? data.data.concat(this.mediaList) : [];
        this.mediaCurrent = data.total;
        this.addUrgentImgLoding = false;
      });
    },
    userDefinedPlayTime(value) {
      console.log(isNaN(Number(value)));
      if (isNaN(Number(value))) {
        this.$msg({ type: 'warning', message: this.$t('ctch42') });
        this.emergencyOrderInfo.playTime = 10;
      } else {
        this.emergencyOrderInfo.playTime = Number(value);
      }
    },
    sendEmergencyOrder(type) {
      if (this.emergencyOrderInfo.text === "" && type === 'on') {
        this.$msg({ type: 'warning', message: this.$t('ctch43') });
        return;
      }
      if (type === 'on') {
        this.$confirm(
          <div class="flex-d-a-c">
            <div style="margin-bottom:16px">{this.$t('ctch44')}</div>
            <div style="color:red;width:90%;">
              <p>{this.emergencyOrderInfo.text}</p>
            </div>
          </div>,
          this.$t('ctch45'), {
        }).then(() => {
          let urgent = this.emergencyOrderInfoFormatting(superClone(this.emergencyOrderInfo));
          urgent.playTime = urgent.playTime * 1000;
          urgent.turnPageTime = urgent.turnPageTime * 1000;
          // urgent.playRank = 1000000 - urgent.playRank;
          this.invokeMethodToKP('sendTextInfo', { ...urgent }, true)
          this.$message({ type: 'success', message: this.$t('ctch46') });
          this.sendUrgentMsgDv = false;
          this.emergencyOrderInfo = superClone(urgentInfo);
        }).catch(() => { });
      }
      // if (type === 'off') {
      //   this.$confirm("确定紧急取消显示信息?", '紧急信息', {
      //   }).then(() => {
      //     this.invokeMethodToKP('cancelTextInfo', {}, true)
      //     this.$message({
      //       type: 'success',
      //       message: '取消成功!'
      //     });
      //   }).catch(() => { });
      // }

      // if (type === 'openMode') {
      //   this.programPlayModel = true;
      // }
    },
    emergencyOrderInfoFormatting(val) {
      // console.log(val);
      let { bgColor, textColor, playTime } = val;
      bgColor = rgbaToHex(bgColor.replace(/\s+/g, "")).hex10;
      textColor = rgbaToHex(textColor.replace(/\s+/g, "")).hex10;
      playTime = hmsToSec(timeFormatting(playTime));
      // console.log(bgColor, textColor, playTime);
      return { ...this.emergencyOrderInfo, ...{ bgColor, textColor, playTime } }
    },
    // sendOffUrgent(val) {
    //   // console.log(val);
    //   let orderType = '';
    //   if (val === 'send') {
    //     orderType = 'send_text_info';
    //   }
    //   if (val === 'off') {
    //     orderType = 'cancel_text_info';
    //   }
    //   if (val === 'program_play_by_name') {
    //     orderType = 'program_play_by_name';
    //   }

    //   this.handleTimeLimit(orderType);
    // },
    programPlayModelConfirm(isConfirm) {
      if (isConfirm === true) {
        this.invokeMethodToKP('programPlaylndex', { index: this.emergencyOrderInfo.modeIndex }, true)
      }
      if (isConfirm === false) {
        // this.invokeMethodToKP('set_media_log', { status: 0 }, true)
      }
      this.programPlayModel = false;
    },
    streamingMediaConfirm(isConfirm) {
      if (isConfirm === true) {
        this.streamingMedia.open = this.streamingMedia.open ? 1 : 0;
        // console.log(this.streamingMedia);
        this.invokeMethodToKP('set_auto_stream', { ...this.streamingMedia }, true);
      }
      if (isConfirm === false) {
        console.log(isConfirm);
      }
      this.streamingMediaDv = false;
    },
    urgentTemplateConfirm(isConfirm) {
      if (isConfirm === true) {
        if (this.urgentProgramsId !== -1) {
          let content = this.urgentProgramsList.find((up) => up.id === this.urgentProgramsId).content;
          this.invokeMethodToKP('program_play_by_name', { programName: content }, true);
        }
      }
      if (isConfirm === false) {
        // this.invokeMethodToKP('set_media_log', { status: 0 }, true)
      }
      this.urgentTemplate = false;
    },
    setFontSize(val) {
      if (typeof (val) === "number") {
        this.emergencyOrderInfo.textSize = val;
      }
    },
    getUrgentPrograms() {
      this.$http.post("/admin/publish/getUrgentPrograms", {
        type: 'list',
        user_id: this.$cookies.get('user_id')
      }, data => {
        this.urgentProgramsList = data;
        this.urgentProgramsList.length > 0 && (this.urgentProgramsId = this.urgentProgramsList[0].id);
        // console.log(data);
      });
    },
    getUrgentText() {
      this.$http.post("/admin/publish/getUrgentText", {
        user_id: this.$cookies.get('user_id')
      }, data => {
        this.urgentTextList = data;
      });
    },
    selectUrgentText(val) {
      let content = this.urgentTextList.find(ut => ut.id === val).content;
      this.emergencyOrderInfo.text = content;
    },
    async setBrightAndLight() {
      switch (this.orderType) {
        case 'setting/bright': {
          this.invokeMethodToKP('setting/bright', {
            bright: this.lightForm.value
          }, true)
        }
          break
        case 'setting/voice': {
          this.invokeMethodToKP('setting/voice', {
            voice: this.lightForm.value / 100
          }, true)
        }
      }
      this.lightForm.value = 50;
    },
    handleOrder(type) {
      let commands_info = uriEncode([{
        type: type,
        data: [],
      },]);
      console.log(commands_info);
      this.order_now_time = Date.parse(new Date()) / 1000;
      if (
        Number(this.order_now_time) - Number(this.orderTime) <
        orderTimeLimit
      ) {
        //console.log("小于.....");
        this.$msg({
          message: `${this.$t('terminal.timeLimit')}${orderTimeLimit}${this.$t('terminal.timeLimitTip')}${orderTimeLimit -
            (this.order_now_time - this.orderTime)}${this.$t('terminal.seconds')}`,
        });
      } else {
        //console.log("不小于....");
        this.orderTime = Date.parse(new Date()) / 1000;
        this.invokeMethodToKP(type, {}, true, type)
      }
    },

    getDcinfo(ids, generResult) { //发送设备指令后，获得命令反馈
      let ymd = dateFormat(new Date());
      let hms = timeFormatting(new Date());
      let retime = ymd + ' ' + hms;
      generResult.result.forEach((ele) => {
        switch (ele.type) {
          case 'onscreen_control': //开屏
            ele.type = "terminal.onscreen";
            break;
          case 'offscreen_control': //关屏
            ele.type = "terminal.action4";
            break;
          case 'restart_control': //重启
            ele.type = 'terminal.reboot';
            break;
          case 'capture_save': //截屏
            ele.type = '截屏';
            break;
          case 'schedule_setting': //定时指令
            ele.type = 'terminal.timeTask';
            break;
          case 'setting/bright': //亮度调节
            ele.type = 'terminal.conBright';
            break;
          case 'setting/voice': //音量调节
            ele.type = 'terminal.conVoice';
            break;
          case 'invoke_method':
            // if (ele.data.methodName == 'setting/bright') {
            // 	ele.type = '亮度设置'
            // } else if (ele.data.methodName == 'setting/voice') {
            // 	ele.type = '音量设置'
            // } else if (ele.data.methodName == 'setAllRelay') {
            // 	ele.type = '继电器控制'
            // }
            switch (ele.data.methodName) {
              case 'setting/bright':
                ele.type = 'terminal.conBright';
                break;
              case 'setting/voice':
                ele.type = 'terminal.conVoice';
                break;
              case 'setAllRelay': //继电器开关
                ele.type = 'terminal.relay';
                break;
              case 'setSignalInput': //信号切换
                ele.type = 'terminal.signalChange';
                break;
              case 'setSyncPlay':
                ele.type = 'terminal.synScreen'; //多屏同步
                break;
              case 'scheduleRunning': //定时播放开关
                ele.type = 'terminal.timePlay';
                break;
              case 'setPowerOnOff': //定时开关机
                ele.type = 'terminal.timeOn';
                break;
              case 'setTimeZoneId': //时区校准
                ele.type = "terminal.timeZone";
                break;
              case 'set_cloud_monitor_time': //云看护
                ele.type = 'ctch48';
                break;
              case 'set_cloud_reboot_status': //云看护
                ele.type = 'ctch49';
                break;
              case 'set_media_log': //日志上传
                ele.type = 'ctch50';
                break;
              case 'sendTextInfo': //紧急消息发布
                ele.type = 'ctch51';
                break;
              case 'cancelTextInfo': //紧急消息取消
                ele.type = 'ctch52';
                break;
              case 'programPlaylndex': //紧急消息模式
                ele.type = 'ctch53';
                break;
              case 'program_play_by_name': //紧急版式
                ele.type = 'ctch54';
                break;
              case 'schedule_back': //播表撤回
                ele.type = 'ctch55';
                break;

            }
            break;
          default:
        }
        this.feedback = sessionStorage.getItem('orderFeedBack') ? JSON.parse(sessionStorage.getItem(
          'orderFeedBack')) : [];
        this.feedback.push({
          command_id: ele.id,
          command_type: ele.type,
          command_state: 1,
          command_result: '已发送',
          create_time: retime,
          device_name: ele.device_name
        });
        sessionStorage.setItem('orderFeedBack', JSON.stringify(this
          .feedback));
        this.$emit('orderBack', this.feedback, false);
      })
      let d_ids = ids.toString(); //参数的ids
      let i = 0;
      let inter = setInterval(() => {
        i += 1;
        this.$http.post('/admin/command/getDcInfo', {
          dc_ids: d_ids
        }, data => {
          let idArray = d_ids.split(",");
          data.dc_infos.forEach((ele) => {
            this.feedback.forEach((val) => {
              if (val.command_id == ele.id) {
                val.command_state = ele.command_state;
              }
              sessionStorage.setItem('orderFeedBack', JSON.stringify(this
                .feedback));
            })
            this.$emit('orderBack', this.feedback, false);
            if (ele.command_state != 1) {
              idArray.splice(idArray.indexOf(ele.id.toString()), 1);
              if (idArray.length == 0) {
                //console.log('ids为0执行成功',this.feedback)
                this.$emit('orderBack', this.feedback, true);
                sessionStorage.setItem('orderFeedBack', JSON.stringify(this
                  .feedback));
                clearInterval(inter);
              }
              d_ids = idArray.toString();
            }
          })
        })
        if (i == 15) {
          this.feedback.forEach((ele) => {
            if (ele.command_state == 1) {
              ele.command_state = 3
            }
          })
          sessionStorage.setItem('orderFeedBack', JSON.stringify(this
            .feedback));
          this.$emit('orderBack', this.feedback, true);
          clearInterval(inter);
        }
      }, 1000)
    },
  },
  created() {
    this.playRankOptions = Array.from({ length: 100 }).map((_, index) => ({ value: index, label: index }))
    let feedback = sessionStorage.getItem('orderFeedBack') ? JSON.parse(sessionStorage.getItem('orderFeedBack')) : [];
    this.feedback = feedback;
  }
}
</script>

<style lang="scss" scoped>
.voice-control {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .voicenumber {
    width: 100px;
    margin-left: 10px;
  }
}

.power-time {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: calc(100% - 50px);
}

.s_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .s_head {
    width: 90%;
    display: flex;
    justify-content: space-between;
  }

  .s_table {
    height: 350px;
  }

  .s_footer {
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 10px auto;
  }
}

.inner_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .rows {
    display: flex;
    width: 100%;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 10px;
    justify-content: space-between;
  }
}

.new_template_content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .n_item {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .n_item_button {
    display: flex;
    align-items: center;
    width: 90%;
    justify-content: space-around;
    margin-top: 20px;
  }
}
.e-o-li {
  margin: 16px;
  .title {
    width: 80px;
    margin-right: 8px;
    text-align: right;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.media-list-item {
  width: 144px;
  height: 98px;
  margin: 8px 0px;
  border: 2px solid #fff;
  border-radius: 4px;
}
.media-list-item:hover {
  border: 2px solid #409eff;
  cursor: pointer;
}

.media-list-item-activate {
  border: 2px solid #409eff;
}
</style>
